const constants = require("./constants");

function persistSegment(segment) {
    if (!segment) {
        return;
    }

    try {
        localStorage.setItem("gtmSegment", segment);
    } catch (error) {
        // Tracking must remain fail-safe when localStorage is unavailable.
    }
}

function getStoredSegment() {
    try {
        return localStorage.getItem("gtmSegment") || "";
    } catch (error) {
        return "";
    }
}

function getSegmentFromTabId(tabId) {
    var segments = constants.GTM.SEGMENTS || {};

    return tabId && segments[tabId] ? segments[tabId] : "";
}

function getSegment() {
    var headerSegment = $(".js-header-tab.active li").first().text().trim()
        || $(".mobile-tab-top-bar__segment-text").first().text().trim()
        || ($(".page").attr("data-segment") || "").trim();

    if (headerSegment) {
        persistSegment(headerSegment);
        return headerSegment;
    }

    var tabSegment = getSegmentFromTabId($(".page").attr("data-activetab"));

    if (tabSegment) {
        persistSegment(tabSegment);
        return tabSegment;
    }

    return getStoredSegment();
}

function parseCampaignAttribute(raw) {
    if (!raw || raw === "false") {
        return null;
    }

    try {
        var parsed = JSON.parse(raw);

        if (!parsed || typeof parsed !== "object") {
            return null;
        }

        if (!parsed.campaignSource && !parsed.campaignMedium && !parsed.campaignName) {
            return null;
        }

        return parsed;
    } catch (error) {
        return null;
    }
}

function campaignFromLocation() {
    try {
        var params         = new URLSearchParams(window.location.search);
        var campaignSource = params.get("utm_source") || "";
        var campaignMedium = params.get("utm_medium") || "";
        var campaignName   = params.get("utm_campaign") || "";

        if (!campaignSource && !campaignMedium && !campaignName) {
            return null;
        }

        return {
            campaignSource: campaignSource,
            campaignMedium: campaignMedium,
            campaignName  : campaignName
        };
    } catch (error) {
        return null;
    }
}

function hasCampaignValues(campaignData) {
    return !!(campaignData && (campaignData.campaignSource || campaignData.campaignMedium || campaignData.campaignName));
}

function resolveCampaignData($cartContainer, $gtmElement, isCheckoutPage) {
    var campaignData = isCheckoutPage
        ? parseCampaignAttribute($gtmElement.attr("data-campaign-source"))
        : parseCampaignAttribute($cartContainer.attr("data-campaign-source"));

    if (hasCampaignValues(campaignData)) {
        return campaignData;
    }

    campaignData = parseCampaignAttribute($(".js-campaign-source").attr("data-campaign-source"));

    if (hasCampaignValues(campaignData)) {
        return campaignData;
    }

    return campaignFromLocation();
}

// triggers page_view event
function pageViewEvent() {
    const isCheckoutPage = $(".checkout-page").length;
    const $gtmElement    = $(".gtm-header-checkout");
    const locale         = $(".currentLocationText").first().text();
    const city           = isCheckoutPage ? $gtmElement.attr("data-country") : locale.trim().split("/")[0] || "";
    const area           = isCheckoutPage ? $gtmElement.attr("data-state") : locale.trim().split("/")[1] || "";
    const $cartContainer = $(".js-cart-container");
    var user             = $(".registered-user");
    var userType         = "";
    var userID           = "";
    var language         = "";
    var campaignData     = resolveCampaignData($cartContainer, $gtmElement, isCheckoutPage);

    if (isCheckoutPage) {
        userID   = $gtmElement.attr("data-customer-number");
        language = $gtmElement.attr("data-language");
        userType = $gtmElement.attr("data-customer-number") ? constants.GTM.EVENTS.REGISTERED : constants.GTM.EVENTS.GUEST;
    } else {
        userID   = user.length ? user.attr("data-user-id") : "";
        language = $(".login-header__greetings").attr("data-language");
        userType = user.length ? constants.GTM.EVENTS.REGISTERED : constants.GTM.EVENTS.GUEST;
    }

    pushDataLayer({
        "event": constants.GTM.EVENTS.PAGE_VIEW,
        "city": city,
        "area": area,
        "user_id": userID,
        "user_type": userType,
        "site_language": language,
        "utm_source": campaignData && campaignData.campaignSource || "",
        "utm_campaign": campaignData && campaignData.campaignName || "",
        "utm_medium": campaignData && campaignData.campaignMedium || ""
    });
}

// triggers add_to_cart or remove_from_cart events
function cartEvents(element, label) {
    const $product        = $(element).hasClass("js-toggle-service") ? $(element).parents(".js-service-tile") : $(element).parents(".js-offer-tile");
    const productCategory = $product.find(".offerTile__offerMain p").text().trim() || $product.parents(".js-category-card").find(".category-card__content-title").text().trim();
    const productName     = $product.find(".gtm-product-name").text().trim() || $product.find(".offerTile__offerMain h3").text().trim();
    const productPrice    = Number($product.find(".offerTile__price__main").attr("data-item-price")?.replace(/[^0-9,]/g, "")?.replace(",", "."));
    const currency        = $product.find(".offerTile__price__main").attr("data-currency");
    const productID       = $product.attr("data-package-id") || $product.attr("data-product-id") || $product.attr("data-service-id");
    const operationType   = $(element).data("operation-type");
    const itemListName    = operationType && operationType === constants.PRODUCT_SALE_TYPE.UPDATE ?
        constants.GTM.ITEM_LIST_NAMES.MENU :
        $(element).closest("[data-item-list-name]").attr("data-item-list-name");
    const addToCartType   = $(element).data("should-redirect-to-checkout") ?
        constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CHECKOUT :
        constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CART;

    const dataLayerObj = {
        "event": label,
        "ecommerce": {
            "currency": currency,
            "value": productPrice,
            "items": [{
                "item_name": productName,
                "item_id": productID,
                "price": productPrice,
                "item_category": productCategory,
                "quantity": 1,
                "index": 0,
                "item_list_name": itemListName,
            }]
        }
    };

    if (label === constants.GTM.EVENTS.ADD_TO_CART) {
        dataLayerObj.ecommerce["add_to_cart_type"] = addToCartType;
    }

    pushDataLayer(dataLayerObj);
}

// triggers view_cart event
function viewCartEvent() {
    const currency     = $(".offerTile__price__main").attr("data-currency");
    const basketValue  = Number($(".js-cart-total-price b").first().text().replace(/[^0-9,]/g, "").replace(",", "."));
    const $basketItems = $(".js-cart-summary-item");
    const object       = [];

    $basketItems.each(function (index) {
        const item = {
            "item_name": $(this).find(".cart-summary__item-description").text().trim(),
            "item_id": $(this).attr("data-product-id"),
            "price": Number($(this).find(".cart-summary__item-category-price").text().replace(/[^0-9,]/g, "").replace(",", ".")),
            "item_category": $(this).find(".cart-summary__item-name").text().trim(),
            "quantity": 1,
            "index": index,
            "item_list_name": getItemListName($(this).find(".js-category-product").first().attr("data-product-addition-source"))
        };

        object.push(item);
    });

    pushDataLayer({
        "event": constants.GTM.EVENTS.VIEW_CART,
        "ecommerce": {
            "currency": currency,
            "value": basketValue,
            "items": object
        }
    });
}

function getItemListName(additionSource) {
    switch (additionSource) {
        case constants.GTM.ADDITION_SOURCES.OFFER_TILE:
            return constants.GTM.ITEM_LIST_NAMES.PACKAGE;
        case constants.GTM.ADDITION_SOURCES.CART:
            return constants.GTM.ITEM_LIST_NAMES.CUSTOMIZE_PACKAGE;
        case constants.GTM.ADDITION_SOURCES.OFFER_BANNER:
            return constants.GTM.ITEM_LIST_NAMES.BANNER;
        case constants.GTM.ADDITION_SOURCES.MY_ACCOUNT:
            return constants.GTM.ITEM_LIST_NAMES.MENU;
        case constants.GTM.ADDITION_SOURCES.EXTERNAL:
            return constants.GTM.ITEM_LIST_NAMES.DIRECT;
        default:
            return "";
    }
}

function getCheckoutLoginType() {
    const customerNo = $(".gtm-header-checkout").attr("data-customer-number");

    if (customerNo) {
        return constants.GTM.EVENTS.REGISTERED;
    }

    const $summary = $(".checkout-card__summary").first();

    if ($summary.length && $summary.attr("data-registered-customer") === "true") {
        return constants.GTM.EVENTS.REGISTERED;
    }

    return constants.GTM.EVENTS.GUEST;
}

function isApplianceCheckout() {
    return $(".js-checkout").attr("data-is-appliance-checkout") === "true"
        || $(".payment-gateway").attr("data-is-appliance-checkout") === "true";
}

function getApplianceGtmOptions(checkoutStep) {
    if (!isApplianceCheckout()) {
        return {};
    }

    var productFlow = constants.GTM && constants.GTM.PRODUCT_FLOW
        ? constants.GTM.PRODUCT_FLOW.APPLIANCE
        : "aparelho";

    return {
        checkoutStep: checkoutStep || "",
        productFlow: productFlow
    };
}

function parseLocalizedPrice(value) {
    if (typeof value === "number") {
        return isNaN(value) ? 0 : value;
    }

    var normalizedValue = String(value || "").replace(/[^\d,.-]/g, "");
    var lastCommaIndex  = normalizedValue.lastIndexOf(",");
    var lastDotIndex    = normalizedValue.lastIndexOf(".");

    if (lastCommaIndex > -1 && lastDotIndex > -1) {
        normalizedValue = lastCommaIndex > lastDotIndex
            ? normalizedValue.replace(/\./g, "").replace(",", ".")
            : normalizedValue.replace(/,/g, "");
    } else if (lastCommaIndex > -1) {
        normalizedValue = normalizedValue.replace(",", ".");
    }

    var parsedValue = Number(normalizedValue);

    return isNaN(parsedValue) ? 0 : parsedValue;
}

function getCheckoutSummary() {
    const $desktopSummary = $(".checkout-page__sidebar .gtm-summary").first();

    return $desktopSummary.length ? $desktopSummary : $(".gtm-summary").first();
}

function buildCheckoutItems($summary) {
    const items = [];

    $summary.find(".js-category-product").each(function (index) {
        const $product     = $(this);
        const $category    = $product.closest(".checkout-minicart__item");
        const isRegular    = $product.attr("data-is-regular-product") === "true";
        const additionType = $product.attr("data-product-addition-source");
        const itemListName = isRegular
            ? constants.GTM.ITEM_LIST_NAMES.APPLIANCE
            : getItemListName(additionType);
        const itemName     = $product.attr("data-item-name")
            || $product.find(".checkout-minicart__item-regular-product-name").text().trim()
            || $product.find(".checkout-minicart__item-description").text().trim();
        const itemPrice    = parseLocalizedPrice(
            $product.attr("data-item-price")
            || $product.find(".checkout-minicart__item-regular-product-price").text()
            || $product.find(".checkout-minicart__item-product-price").text()
        );

        items.push({
            "item_name": itemName,
            "item_id": $product.attr("data-product-id") || $category.attr("data-product-id") || "",
            "price": itemPrice,
            "item_category": $product.attr("data-item-category")
                || $category.find(".checkout-minicart__item-name").first().text().trim(),
            "quantity": Number($product.attr("data-item-quantity")) || 1,
            "index": index,
            "item_list_name": itemListName
        });
    });

    return items;
}

function buildLegacyCheckoutItems($summary) {
    const items = [];

    $summary.find(".checkout-minicart__item").each(function (index) {
        const $item = $(this);

        items.push({
            "item_name": $item.find(".checkout-minicart__item-description").text().trim(),
            "item_id": $item.attr("data-product-id") || "",
            "price": parseLocalizedPrice($item.find(".checkout-minicart__item-category-price").text()),
            "item_category": $item.find(".checkout-minicart__item-name").text().trim(),
            "quantity": 1,
            "index": index,
            "item_list_name": getItemListName(
                $item.find(".js-category-product").first().attr("data-product-addition-source")
            )
        });
    });

    return items;
}

function normalizeTrackingContext(value) {
    var normalizedValue = String(value || "").trim();
    var normalizedLower = normalizedValue.toLowerCase();

    return normalizedLower === "null" || normalizedLower === "undefined"
        ? ""
        : normalizedValue;
}

function getTransactionId(options) {
    options = options || {};

    return normalizeTrackingContext(options.transactionId)
        || normalizeTrackingContext($(".gtm-header-checkout").attr("data-order-number"))
        || normalizeTrackingContext($(".payment-gateway").attr("data-order-no"));
}

function getTrackingContextId() {
    return getTransactionId({})
        || normalizeTrackingContext($(".js-checkout").attr("data-gtm-flow-id"));
}

function getTrackingStorageKey(eventKey, contextId) {
    contextId = normalizeTrackingContext(contextId) || getTrackingContextId();

    return contextId ? "gtm_" + eventKey + "_" + contextId : "";
}

function hasTrackedEvent(storageKey) {
    if (!storageKey) {
        return false;
    }

    try {
        return sessionStorage.getItem(storageKey) === "true";
    } catch (error) {
        return false;
    }
}

function markTrackedEvent(storageKey) {
    if (!storageKey) {
        return;
    }

    try {
        sessionStorage.setItem(storageKey, "true");
    } catch (error) {
        // Tracking must remain fail-safe when sessionStorage is unavailable.
    }
}

function pushDataLayer(payload, onceKey, contextId, onProcessed) {
    if (!window.dataLayer) {
        if (onProcessed) {
            onProcessed();
        }

        return false;
    }

    payload.segment = getSegment();

    var storageKey = onceKey ? getTrackingStorageKey(onceKey, contextId) : "";

    if (hasTrackedEvent(storageKey)) {
        if (onProcessed) {
            onProcessed();
        }

        return false;
    }

    if (onProcessed) {
        var callbackCalled   = false;
        var callbackTimeout  = null;
        var completeTracking = function () {
            if (callbackCalled) {
                return;
            }

            callbackCalled = true;
            clearTimeout(callbackTimeout);
            markTrackedEvent(storageKey);
            onProcessed();
        };

        payload.eventCallback = completeTracking;
        payload.eventTimeout  = 1000;
        callbackTimeout       = setTimeout(completeTracking, payload.eventTimeout);
    }

    window.dataLayer.push(payload);

    if (!onProcessed) {
        markTrackedEvent(storageKey);
    }

    return true;
}

function buildCheckoutEventPayload(label, status, options) {
    const $summary          = getCheckoutSummary();
    const currency          = $summary.attr("data-currency") || "";
    const basketValue       = parseLocalizedPrice(
        $summary.attr("data-gtm-value")
        || $summary.closest(".checkout-minicart").find(".js-minicart-total-price b").first().text()
    );
    const checkoutLoginType = options.checkoutLoginType || getCheckoutLoginType();
    const isApplianceFlow   = options.productFlow === constants.GTM.PRODUCT_FLOW.APPLIANCE
        || isApplianceCheckout();

    const ecommerceObject = {
        "currency": currency,
        "value": basketValue,
        "items": isApplianceFlow
            ? buildCheckoutItems($summary)
            : buildLegacyCheckoutItems($summary),
        "checkout_login_type": checkoutLoginType
    };

    switch (label) {
        case "begin_checkout":
            ecommerceObject["checkout_login_type"] = checkoutLoginType;
            break;
        case "add_payment_info":
            ecommerceObject["payment_type"] = options.paymentType
                || $(".payment-methods__options__option input:checked").siblings("label").find("div").text().trim()
                || $(".gtm-header-checkout").attr("data-payment-method")
                || (isApplianceFlow ? "CREDIT_CARD" : "");
            break;
        case "add_shipping_info":
            if (options.shippingTier) {
                ecommerceObject["shipping_tier"] = options.shippingTier;
            }

            break;
        case "purchase":
            ecommerceObject["payment_type"]        = (options.paymentType
                || $(".gtm-header-checkout").attr("data-payment-method")
                || "").trim();
            ecommerceObject["city"]                = $(".gtm-header-checkout").attr("data-country");
            ecommerceObject["area"]                = $(".gtm-header-checkout").attr("data-state");
            ecommerceObject["checkout_login_type"] = checkoutLoginType;
            ecommerceObject["transaction_id"]      = getTransactionId(options);
            ecommerceObject["validation"]          = status;
            break;
        case "purchase_validation":
            ecommerceObject["validation"]     = status;
            break;
        default:
            break;
    }

    const payload = {
        "event": label,
        "ecommerce": ecommerceObject,
        "checkout_login_type": checkoutLoginType
    };

    if (options.checkoutStep) {
        payload.checkout_step = options.checkoutStep;
    }

    if (options.productFlow) {
        payload.product_flow = options.productFlow;
    }

    if (status && label === constants.GTM.EVENTS.PAYMENT_FAILED) {
        payload.event_status = status;
    }

    if (options.failureReason) {
        payload.failure_reason = options.failureReason;
    }

    if (options.transactionId && label !== constants.GTM.EVENTS.PURCHASE) {
        payload.transaction_id = options.transactionId;
    }

    if (label === constants.GTM.EVENTS.ORDER_CREATED
        || label === constants.GTM.EVENTS.PAYMENT_FAILED
        || label === constants.GTM.EVENTS.ABANDONED_PAYMENT) {
        payload.checkout_login_type = checkoutLoginType;
    }

    return payload;
}

function checkoutEvents(label, status, options, onProcessed) {
    options = options || {};

    if (label === constants.GTM.EVENTS.PURCHASE && status !== constants.GTM.EVENTS.SUCCESFULLY) {
        return false;
    }

    const payload   = buildCheckoutEventPayload(label, status, options);
    const trackOnce = label === constants.GTM.EVENTS.PURCHASE
        || label === constants.GTM.EVENTS.PAYMENT_FAILED
        || label === constants.GTM.EVENTS.ADD_SHIPPING_INFO;

    return pushDataLayer(
        payload,
        trackOnce ? label : "",
        trackOnce ? getTransactionId(options) : "",
        onProcessed
    );
}

function trackCheckoutStep(checkoutStep, eventLabel, status, extraOptions, onProcessed) {
    const options = Object.assign({}, getApplianceGtmOptions(checkoutStep), extraOptions || {});

    return checkoutEvents(eventLabel, status, options, onProcessed);
}

function trackPaymentAbandoned() {
    if (!isApplianceCheckout()) {
        return false;
    }

    const options = Object.assign(
        {},
        getApplianceGtmOptions(constants.GTM.CHECKOUT_STEPS.PAYMENT_ABANDONED),
        {
            transactionId: getTransactionId({})
        }
    );
    const payload = buildCheckoutEventPayload(constants.GTM.EVENTS.ABANDONED_PAYMENT, null, options);

    payload.transport_type = "beacon";

    return pushDataLayer(
        payload,
        constants.GTM.EVENTS.ABANDONED_PAYMENT,
        options.transactionId,
        function () {}
    );
}

function trackPaymentGatewayView() {
    var transactionId = getTransactionId({});

    if (isApplianceCheckout()) {
        trackOrderCreated(transactionId);
    }

    return true;
}

function trackAddPaymentInfo(onProcessed) {
    var transactionId = getTransactionId({});
    const options     = Object.assign(
        {},
        getApplianceGtmOptions(constants.GTM.CHECKOUT_STEPS.PAYMENT_GATEWAY),
        {
            paymentType: $(".gtm-header-checkout").attr("data-payment-method") || "",
            transactionId: transactionId
        }
    );
    const payload     = buildCheckoutEventPayload(constants.GTM.EVENTS.ADD_PAYMENT_INFO, null, options);

    return pushDataLayer(
        payload,
        constants.GTM.EVENTS.ADD_PAYMENT_INFO,
        transactionId,
        onProcessed
    );
}

function fireBeginCheckoutOnce(extraOptions) {
    const options = Object.assign({}, extraOptions || {});
    const payload = buildCheckoutEventPayload(constants.GTM.EVENTS.BEGIN_CHECKOUT, null, options);

    if (!pushDataLayer(payload, constants.GTM.EVENTS.BEGIN_CHECKOUT)) {
        return false;
    }

    // Preserve the existing package funnel; appliance shipping is tracked only
    // after the actual delivery/pickup address succeeds.
    if (!options.productFlow) {
        checkoutEvents(constants.GTM.EVENTS.ADD_SHIPPING_INFO, null, options);

        if (!$(".js-checkout-card-installation-address").length) {
            checkoutEvents(constants.GTM.EVENTS.ADD_INSTALL_ADDRESS_INFO, null, options);
        }
    }

    return true;
}

function trackApplianceProductEvent(element, label, onProcessed) {
    const $button         = $(element);
    const productName     = $button.attr("data-item-name") || "";
    const productID       = $button.attr("data-pid") || $button.attr("data-item-id") || "";
    const productPrice    = parseLocalizedPrice($button.attr("data-item-price"));
    const currency        = $button.attr("data-currency") || "";
    const productCategory = $button.attr("data-item-category") || "";
    const isProductTile   = typeof $button.hasClass === "function"
        && $button.hasClass("js-appliance-product-tile");
    const itemListName    = isProductTile
        ? constants.GTM.ITEM_LIST_NAMES.APPLIANCE_PLP
        : constants.GTM.ITEM_LIST_NAMES.APPLIANCE;
    const ecommerceObject = {
        "currency": currency,
        "value": productPrice,
        "items": [{
            "item_name": productName,
            "item_id": productID,
            "price": productPrice,
            "item_category": productCategory,
            "quantity": 1,
            "index": 0,
            "item_list_name": itemListName
        }]
    };
    const legacyProduct   = {
        "id": productID,
        "name": productName,
        "price": productPrice,
        "category": productCategory,
        "quantity": 1
    };

    if (label === constants.GTM.EVENTS.ADD_TO_CART) {
        ecommerceObject["add_to_cart_type"] = constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CHECKOUT;
        ecommerceObject["add"]              = {
            "products": [legacyProduct]
        };
        ecommerceObject["phone_insurance_included"] = false;
        ecommerceObject["phone_insurance_choice"]   = constants.GTM.PHONE_INSURANCE_CHOICE.NOT_OFFERED;
    }

    if (label === constants.GTM.EVENTS.SELECT_ITEM) {
        ecommerceObject["purchase"] = {
            "products": [legacyProduct]
        };
    }

    const payload = {
        "event": label,
        "product_flow": constants.GTM.PRODUCT_FLOW.APPLIANCE,
        "ecommerce": ecommerceObject
    };

    if (label === constants.GTM.EVENTS.ADD_TO_CART) {
        payload.phone_insurance_included = false;
        payload.phone_insurance_choice   = constants.GTM.PHONE_INSURANCE_CHOICE.NOT_OFFERED;
    }

    return pushDataLayer(payload, "", "", onProcessed);
}

function trackApplianceAddToCart(element, onProcessed) {
    return trackApplianceProductEvent(element, constants.GTM.EVENTS.ADD_TO_CART, onProcessed);
}

function buildLegacyApplianceProduct(item) {
    return {
        "id": item.item_id,
        "name": item.item_name,
        "price": item.price,
        "category": item.item_category,
        "quantity": item.quantity
    };
}

function pushApplianceAddToCartPayload(options, onProcessed) {
    const phoneInsuranceChoice   = options.phoneInsuranceChoice || constants.GTM.PHONE_INSURANCE_CHOICE.NOT_OFFERED;
    const phoneInsuranceIncluded = !!options.phoneInsuranceIncluded;
    const phoneItem              = {
        "item_name": options.productName || "",
        "item_id": options.pid || "",
        "price": parseLocalizedPrice(options.price),
        "item_category": options.itemCategory || "Aparelhos",
        "quantity": 1,
        "index": 0,
        "item_list_name": options.phoneItemListName || constants.GTM.ITEM_LIST_NAMES.APPLIANCE
    };

    if (options.itemVariant) {
        phoneItem.item_variant = options.itemVariant;
    }

    const items                  = [phoneItem];
    var totalValue               = phoneItem.price;

    if (phoneInsuranceIncluded && options.insurancePlan) {
        const plan = options.insurancePlan;

        items.push({
            "item_name": plan.name || "Seguro Celular",
            "item_id": plan.id || options.insuranceProductId || "",
            "price": parseLocalizedPrice(plan.price),
            "item_category": plan.category || "Seguro Celular",
            "quantity": 1,
            "index": 1,
            "item_list_name": constants.GTM.ITEM_LIST_NAMES.APPLIANCE_INSURANCE
        });
        totalValue += parseLocalizedPrice(plan.price);
    }

    const legacyProducts = items.map(buildLegacyApplianceProduct);
    const ecommerceObject = {
        "currency": options.currency || "",
        "value": totalValue,
        "add_to_cart_type": constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CHECKOUT,
        "phone_insurance_included": phoneInsuranceIncluded,
        "phone_insurance_choice": phoneInsuranceChoice,
        "add": {
            "products": legacyProducts
        },
        "items": items
    };

    if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
    }

    return pushDataLayer({
        "event": constants.GTM.EVENTS.ADD_TO_CART,
        "product_flow": constants.GTM.PRODUCT_FLOW.APPLIANCE,
        "phone_insurance_included": phoneInsuranceIncluded,
        "phone_insurance_choice": phoneInsuranceChoice,
        "ecommerce": ecommerceObject
    }, "", "", onProcessed);
}

/**
 * add_to_cart após Product-Insurance (fluxo intercepta o AJAX da PDP).
 * Aparelho sem proteção (declined) ou com proteção (included + item de seguro).
 */
function readPhoneInsuranceContext() {
    const $context = $(".js-phone-insurance-gtm");

    return {
        pid: $context.attr("data-pid"),
        productName: $context.attr("data-item-name"),
        price: $context.attr("data-item-price"),
        itemCategory: $context.attr("data-item-category"),
        currency: $context.attr("data-currency"),
        insuranceProductId: $context.attr("data-insurance-product-id"),
        insuranceCategory: $context.attr("data-insurance-category") || "Seguro Celular"
    };
}

function trackPhoneInsuranceAddToCart(includeInsurance, onProcessed) {
    const context = readPhoneInsuranceContext();
    const phonePayload = {
        pid: context.pid,
        productName: context.productName,
        price: context.price,
        itemCategory: context.itemCategory,
        currency: context.currency,
        phoneInsuranceIncluded: !!includeInsurance,
        phoneInsuranceChoice: includeInsurance
            ? constants.GTM.PHONE_INSURANCE_CHOICE.INCLUDED
            : constants.GTM.PHONE_INSURANCE_CHOICE.DECLINED
    };

    if (!includeInsurance) {
        return pushApplianceAddToCartPayload(phonePayload, onProcessed);
    }

    const $selectedPlan = $('input[name="insurance-plan"]:checked');

    // A tag de aparelho lê um item por add_to_cart (items[0] / add.products[0]).
    // O segundo evento leva só o Seguro Celular, com o mesmo item_list_name e o
    // preço do line item (à vista), para a tag de proteção disparar.
    return pushApplianceAddToCartPayload(phonePayload, function () {
        pushApplianceAddToCartPayload({
            pid: context.insuranceProductId,
            productName: context.insuranceCategory,
            price: $selectedPlan.attr("data-plan-price"),
            itemCategory: context.insuranceCategory,
            itemVariant: $selectedPlan.attr("data-plan-name") || "",
            phoneItemListName: constants.GTM.ITEM_LIST_NAMES.APPLIANCE,
            currency: context.currency,
            phoneInsuranceIncluded: true,
            phoneInsuranceChoice: constants.GTM.PHONE_INSURANCE_CHOICE.INCLUDED
        }, onProcessed);
    });
}

function trackApplianceAddToCartFromPendingData(data, onProcessed) {
    if (!data || !data.pid) {
        if (onProcessed) {
            onProcessed();
        }

        return false;
    }

    const includeInsurance = !!data.phoneInsuranceIncluded;

    return pushApplianceAddToCartPayload({
        pid: data.pid,
        productName: data.productName,
        price: data.price,
        itemCategory: data.itemCategory,
        currency: data.currency,
        phoneInsuranceIncluded: includeInsurance,
        phoneInsuranceChoice: data.phoneInsuranceChoice || constants.GTM.PHONE_INSURANCE_CHOICE.SKIPPED,
        insuranceProductId: data.insuranceProductId,
        insurancePlan: includeInsurance ? {
            id: data.insuranceProductId,
            name: data.insurancePlanName,
            price: data.insurancePlanPrice,
            category: data.insuranceCategory || "Seguro Celular"
        } : null
    }, onProcessed);
}

function firePendingApplianceAddToCartIfAny() {
    const $checkout = $(".js-checkout");
    const raw       = $checkout.attr("data-pending-appliance-add-to-cart-gtm");

    if (!raw) {
        return false;
    }

    $checkout.removeAttr("data-pending-appliance-add-to-cart-gtm");

    try {
        return trackApplianceAddToCartFromPendingData(JSON.parse(raw));
    } catch (error) {
        return false;
    }
}

function trackApplianceViewItem(element) {
    return trackApplianceProductEvent(element, constants.GTM.EVENTS.VIEW_ITEM);
}

function trackApplianceSelectItem(element, onProcessed) {
    return trackApplianceProductEvent(element, constants.GTM.EVENTS.SELECT_ITEM, onProcessed);
}

function trackApplianceViewItemList(elements) {
    const items  = [];
    var currency = "";

    $(elements).each(function (index) {
        const $product = $(this);

        currency = currency || $product.attr("data-currency") || "";
        items.push({
            "item_name": $product.attr("data-item-name") || "",
            "item_id": $product.attr("data-item-id") || "",
            "price": parseLocalizedPrice($product.attr("data-item-price")),
            "item_category": $product.attr("data-item-category") || "",
            "quantity": 1,
            "index": index,
            "item_list_name": constants.GTM.ITEM_LIST_NAMES.APPLIANCE_PLP
        });
    });

    if (!items.length) {
        return false;
    }

    return pushDataLayer({
        "event": constants.GTM.EVENTS.VIEW_ITEM_LIST,
        "product_flow": constants.GTM.PRODUCT_FLOW.APPLIANCE,
        "ecommerce": {
            "currency": currency,
            "items": items
        }
    });
}

function trackPaymentFailure(failedValidator, onProcessed) {
    var isTrustCardFailure = failedValidator === "serasaTrustCardScore"
        || failedValidator === "serasaTrustCardInsightsValidation"
        || failedValidator === "trustCardService";
    var checkoutStep       = isTrustCardFailure
        ? constants.GTM.CHECKOUT_STEPS.TRUSTCARD_REJECTED
        : constants.GTM.CHECKOUT_STEPS.PAYMENT_FAILED;

    return trackCheckoutStep(
        checkoutStep,
        constants.GTM.EVENTS.PAYMENT_FAILED,
        constants.GTM.EVENTS.FAILED,
        {
            failureReason: failedValidator || "payment_failed",
            transactionId: getTransactionId({})
        },
        onProcessed
    );
}

function trackOrderCreated(transactionId, onProcessed) {
    const options = Object.assign(
        {},
        getApplianceGtmOptions(constants.GTM.CHECKOUT_STEPS.ORDER_CREATED),
        {
            transactionId: transactionId || getTransactionId({})
        }
    );
    const payload = buildCheckoutEventPayload(constants.GTM.EVENTS.ORDER_CREATED, null, options);

    return pushDataLayer(
        payload,
        constants.GTM.EVENTS.ORDER_CREATED,
        options.transactionId,
        onProcessed
    );
}

// triggers view_item_list event
function viewItemListEvent(element) {
    const $carousel    = $(element).find(".js-offer-tile");
    const currency     = $carousel.find(".offerTile__price__main").first().attr("data-currency");
    var objects        = [];
    const batchSize    = 10;
    const itemListName = constants.GTM.ITEM_LIST_NAMES.PACKAGE;

    $carousel.each(function (index) {
        const item = {
            "item_name": $(this).find(".gtm-product-name").text().trim(),
            "item_id": $(this).attr("data-package-id"),
            "price": Number($(this).find(".offerTile__price__main").attr("data-item-price").replace(/[^0-9,]/g, "").replace(",", ".")),
            "item_category": $(this).find(".offerTile__offerMain p").text().trim(),
            "quantity": 1,
            "index": index,
            "item_list_name": itemListName
        };

        objects.push(item);

        if (objects.length === batchSize) {
            pushDataLayer({
                "event": constants.GTM.EVENTS.VIEW_ITEM_LIST,
                "ecommerce": {
                    "currency": currency,
                    "items": objects
                }
            });
            objects = [];
        }
    });

    if (objects.length > 0) {
        pushDataLayer({
            "event": constants.GTM.EVENTS.VIEW_ITEM_LIST,
            "ecommerce": {
                "currency": currency,
                "items": objects
            }
        });
    }
}

// tracks select_promotion event
function trackSelectPromotion(element, label) {
    if (!element) {
        pushDataLayer({
            "event": constants.GTM.EVENTS.SELECT_PROMOTION
        });
        return;
    }

    const $element         = $(element);
    const currency         = $("[data-currency]").first().attr("data-currency");
    const $productElements = $element.find(".gtm-banner-product");
    const object           = [];
    const itemListName     = constants.GTM.ITEM_LIST_NAMES.BANNER;
    const addToCartType    = $element.data("should-redirect-to-checkout") ?
        constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CHECKOUT :
        constants.GTM.ADD_PRODUCT_TO_CART_TYPE.CART;
    var totalOfferValue    = 0;

    $productElements.each(function (index) {
        const item = {
            "item_name": $(this).find(".gtm-banner-name").attr("gtm-banner-data"),
            "item_id": $(this).find(".gtm-banner-id").attr("gtm-banner-data"),
            "price": Number($(this).find(".gtm-banner-price").attr("gtm-banner-data")),
            "item_category": $(this).find(".gtm-banner-category").attr("gtm-banner-data"),
            "quantity": 1,
            "index": index
        };

        totalOfferValue += Number($(this).find(".gtm-banner-price").attr("gtm-banner-data").replace(",", "."));
        object.push(item);
    });

    const ecommerceObject = {
        "currency": currency,
        "value": totalOfferValue,
        "item_list_name": itemListName,
        "items": object
    };

    if (label === constants.GTM.EVENTS.ADD_TO_CART) {
        ecommerceObject["add_to_cart_type"] = addToCartType;
    }

    pushDataLayer({
        "event": label,
        "ecommerce": ecommerceObject
    });
}

// tracks modify_cart event
function trackModify(element) {
    const $element  = $(element);
    const eventType = $element.find(".category-card__content-title").text().trim();

    pushDataLayer({
        "event": constants.GTM.EVENTS.MODIFY_CART,
        "event_type": eventType
    });
}

// tracks error event
function trackError() {
    const errorMessage = $(".error-page h1").text().trim() || $(".error-page__message").first().text().trim();
    const errorType    = constants.GTM.EVENTS.ERROR_404;

    pushDataLayer({
        "event": constants.GTM.EVENTS.ERROR,
        "error_type": errorType,
        "error_message": errorMessage
    });
}

// tracks login event
function trackLogin() {
    pushDataLayer({
        "event": constants.GTM.EVENTS.LOGIN,
        "method": constants.GTM.EVENTS.EMAIL
    });
}

// tracks form_submit event
function trackFormSubmit(formType) {
    pushDataLayer({
        "event": constants.GTM.EVENTS.FORM_SUBMIT,
        "form_type": formType
    });
}

// tracks if the validation step was successful/failed
function trackValidation(eventType) {
    const options = getApplianceGtmOptions(constants.GTM.CHECKOUT_STEPS.IDENTITY_VALIDATION);
    const payload = {
        "event": constants.GTM.EVENTS.PURCHASE_VALIDATION,
        "event_type": eventType
    };

    if (options.checkoutStep) {
        payload.checkout_step = options.checkoutStep;
    }

    if (options.productFlow) {
        payload.product_flow = options.productFlow;
    }

    pushDataLayer(payload);
}

// tracks remove_from_cart event when clearing basket from modal
function trackRemoveFromCart() {
    const currency    = $(".minicart").attr("data-minicart-currency");
    const basketValue = $(".minicart").attr("data-minicart-basket-value");

    pushDataLayer({
        "event": constants.GTM.EVENTS.REMOVE_FROM_CART,
        "ecommerce": {
            "currency": currency,
            "value": basketValue
        }
    });
}

// triggers start_purchase_validation event when reaching the checkout validation step
function trackPurchaseValidationStart() {
    const options = getApplianceGtmOptions(constants.GTM.CHECKOUT_STEPS.IDENTITY_VALIDATION);
    const payload = {
        "event": constants.GTM.EVENTS.START_PURCHASE_VALIDATION
    };

    if (options.checkoutStep) {
        payload.checkout_step = options.checkoutStep;
    }

    if (options.productFlow) {
        payload.product_flow = options.productFlow;
    }

    pushDataLayer(payload, constants.GTM.EVENTS.START_PURCHASE_VALIDATION);
}

module.exports.pageViewEvent                = pageViewEvent;
module.exports.cartEvents                   = cartEvents;
module.exports.viewCartEvent                = viewCartEvent;
module.exports.checkoutEvents               = checkoutEvents;
module.exports.viewItemListEvent            = viewItemListEvent;
module.exports.trackModify                  = trackModify;
module.exports.trackError                   = trackError;
module.exports.trackLogin                   = trackLogin;
module.exports.trackFormSubmit              = trackFormSubmit;
module.exports.trackValidation              = trackValidation;
module.exports.trackSelectPromotion         = trackSelectPromotion;
module.exports.trackRemoveFromCart          = trackRemoveFromCart;
module.exports.trackPurchaseValidationStart = trackPurchaseValidationStart;
module.exports.getCheckoutLoginType         = getCheckoutLoginType;
module.exports.isApplianceCheckout          = isApplianceCheckout;
module.exports.getApplianceGtmOptions       = getApplianceGtmOptions;
module.exports.trackCheckoutStep            = trackCheckoutStep;
module.exports.trackPaymentAbandoned        = trackPaymentAbandoned;
module.exports.trackPaymentGatewayView      = trackPaymentGatewayView;
module.exports.trackAddPaymentInfo          = trackAddPaymentInfo;
module.exports.fireBeginCheckoutOnce        = fireBeginCheckoutOnce;
module.exports.trackApplianceAddToCart      = trackApplianceAddToCart;
module.exports.trackPhoneInsuranceAddToCart = trackPhoneInsuranceAddToCart;
module.exports.firePendingApplianceAddToCartIfAny = firePendingApplianceAddToCartIfAny;
module.exports.trackApplianceViewItem       = trackApplianceViewItem;
module.exports.trackApplianceSelectItem     = trackApplianceSelectItem;
module.exports.trackApplianceViewItemList   = trackApplianceViewItemList;
module.exports.trackPaymentFailure          = trackPaymentFailure;
module.exports.trackOrderCreated            = trackOrderCreated;
module.exports.parseLocalizedPrice          = parseLocalizedPrice;
